'use strict';

var Reflux = require('reflux');

/* Actions */
var ModuleTypeActions = require('actions/module-type');

/* API */
var ModuleTypeApi = require('api/module-type');

/* Stores */
var AuthenticationStore = require('./authentication');

var ModuleTypeStore = Reflux.createStore({

  listenables: ModuleTypeActions,

  init: function init() {
    var store = this;

    store.moduleTypes = [];
    store.typesLoaded = false;
  },

  getInitialState: function getInitialState() {
    var store = this;
    var moduleTypes = store.moduleTypes;

    return moduleTypes;
  },

  onAuthenticationStoreChange: function onAuthenticationStoreChange(data) {
    var store = this;
    var loggedIn = data.loggedIn;
  },

  onLoadModuleTypes: function onLoadModuleTypes() {
    var store = this;

    ModuleTypeApi.load().done(function (data) {
      store.typesLoaded = true;
      store.moduleTypes = data;
      store.trigger(store.moduleTypes);
    });
  }

});

module.exports = ModuleTypeStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/module-type.js
 **/